// import { PricingCalculation } from '@atlassian/bxp-product-pricing';
// import { PricingPlan } from '@atlassian/bxp-product-pricing/dist/types/src/utils';
// import { usePricingCalculator } from '../contexts';
// import { AsyncResult, useAsync } from './use-async';
//
// export function useCalculation(
//   units: number,
//   pricingPlan: PricingPlan,
//   currencyIsoCode: string
// ): AsyncResult<PricingCalculation> {
//   const calculator = usePricingCalculator();
//   return useAsync(
//     () =>
//       calculator.calculatePriceWithPricingPlan({
//         units,
//         currencyIsoCode,
//         pricingPlan
//       }),
//     [units, pricingPlan, currencyIsoCode]
//   );
// }
